<template lang="pug">
  .flex(:style="`height: ${pxToRem(height)}`")
</template>
<script>
export default {
  name: 'Flex',
  props: { height: {} },
  data() {
    return {
      shrink: 1,
    }
  },
  computed: {},
  methods: {
    pxToRem(px) {
      return `${px * 0.01}rem`
    },
  },
  created() {
    let designRatio = 1624 / 750
    let ratio = window.innerHeight / window.innerWidth
    this.shrink = ratio / designRatio
    this.shrink = 0
    console.log(designRatio, ratio, this.shrink)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.flex
  width: 100%
  flex-shrink: 1
  //background: red
</style>
